import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation createProjectMutation($input: CreateProjectMutationInput!) {
        createProject(input: $input) {
            project {
                serviceId
                createdDate
                name
                portfolio {
                    serviceId
                }
            }
        }
    }
`;

export function commit(environment, args) {
    const { name, onCompleted, onError, userId } = args;

    return commitMutation(environment, {
        mutation,
        variables: {
            input: {
                name,
                userId,
            },
        },
        onCompleted,
        onError,
    });
}

export default { commit };
